import { render, staticRenderFns } from "./AudioPlayButton.vue?vue&type=template&id=2736cafd&scoped=true&"
import script from "./AudioPlayButton.vue?vue&type=script&lang=js&"
export * from "./AudioPlayButton.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayButton.vue?vue&type=style&index=0&id=2736cafd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736cafd",
  null
  
)

export default component.exports